import React from 'react'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import Link from '../Link'
import autobind from '../../lib/autobind'

import '../../styles/index.scss'

const ARROW_LEFT = 37
const ARROW_UP = 38
const ARROW_RIGHT = 39
const ARROW_DOWN = 40

class SubmenuItem extends React.Component {
  constructor (props, context) {
    super(props, context)
    autobind(this)
  }

  componentDidMount () {
    if (this.context && this.context.dropdown) {
      this.context.dropdown.registerItem(this.element)
    }
  }

  addReference (element) {
    this.element = this.props.href || this.props.to
      ? findDOMNode(element)
      : element
  }

  handleOnBlur () {
    this.context.dropdown.closeSubmenu()
  }

  handleOnFocus () {
    this.context.dropdown.updateActiveItem(this.element)
    this.context.dropdown.openSubmenu()
  }

  onArrowLeft (e) {
    e.preventDefault()
    this.context.dropdown.closeSubmenu(0)
    this.context.menubar.focusPrevItem()
  }

  onArrowUp (e) {
    e.preventDefault()
    this.context.dropdown.focusPrevItem()
  }

  onArrowRight (e) {
    e.preventDefault()
    this.context.dropdown.closeSubmenu(0)
    this.context.menubar.focusNextItem()
  }

  onArrowDown (e) {
    e.preventDefault()
    this.context.dropdown.focusNextItem()
  }

  handleOnKeyDown (e) {
    switch (e.keyCode) {
      case ARROW_LEFT:
        this.onArrowLeft(e)
        break
      case ARROW_UP:
        this.onArrowUp(e)
        break
      case ARROW_RIGHT:
        this.onArrowRight(e)
        break
      case ARROW_DOWN:
        this.onArrowDown(e)
        break
      default:
    }
  }

  render () {
    let Type = 'button'

    if (this.props.to) Type = Link
    else if (this.props.href) Type = 'a'

    return (
      <Type
        {...this.props}
        ref={this.addReference}
        onKeyDown={this.handleOnKeyDown}
        onFocus={this.handleOnFocus}
        onBlur={this.handleOnBlur}
        tabIndex={this.context.dropdown.isOpen ? 0 : -1}
      >
        {this.props.children}
      </Type>
    )
  }
}

SubmenuItem.contextTypes = {
  menubar: PropTypes.object,
  dropdown: PropTypes.object
}

export default SubmenuItem
